export const formatDate = (dateValue) => {
  if (!dateValue) return '';
  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return '';
  return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
};

export const parseDate = (dateText) => {
  if (!dateText) return null;
  const [day, month, year] = dateText.split('-').map(Number);
  if (!day || !month || !year) return null;
  return new Date(year, month - 1, day);
};
